import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { submitLead } from "../../../leadService";
import LayerFour from "../../../assets/images/layers/Layer_4.png";
import Image from "react-bootstrap/Image";
import { Row, Col } from "react-bootstrap";

const WhitepaperModal = ({
  show,
  onHide,
  whitepaperTitle = "Whitepaper Title",
  whitepaperPdfFile = "/whitepaper.pdf",
}) => {
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [responseMessage, setResponseMessage] = useState("");
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    company: "",
    mobile: "",
  });

  const businessEmailRegex =
    /@(gmail\.com|yahoo\.com|outlook\.com|hotmail\.com|aol\.com|icloud\.com|protonmail\.com|zoho\.com|mail\.com|gmx\.com)$/i;

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  // ✅ Validation
  const validate = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = "Full Name is required";
    }

    if (!formData.email.trim()) {
      newErrors.email = "Business Email is required";
    } else if (businessEmailRegex.test(formData.email)) {
      newErrors.email = "Please use business email";
    }

    if (!formData.company.trim()) {
      newErrors.company = "Company Name is required";
    }

    if (formData.mobile && !/^\d{10}$/.test(formData.mobile)) {
      newErrors.mobile = "Enter valid 10-digit number";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // ✅ Submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setResponseMessage("");
    setErrors({});

    if (!validate()) {
      setLoading(false);
      setResponseMessage("Please correct the errors.");
      return;
    }


    try {
      const response = await submitLead("whitepaper", {
          ...formData,
          title: whitepaperTitle,
          pdf: whitepaperPdfFile,
        });

      if (response.success) {
        setIsSubmitted(true);
        setResponseMessage("Thanks! Check your email for download link.");

      } else {
        setResponseMessage(response.message);
      }
    } catch (err) {
      setResponseMessage("Error submitting form.");
    }

    setLoading(false);
  };

  return (
    <>
      <style>{`
        .popup-header.modal-header {
          border-bottom: 0;
        }
        .popup-header .btn-close {
          position: absolute;
          right: 20px;
        }
        .popup-header-content {
          display: flex;
          align-items: center;
          gap: 20px;
        }
        .popup-image {
          width: 100px;
          height: 100px;
          object-fit: cover;
          border-radius: 8px;
        }
        .error-text {
          color: #d9534f;
          font-size: 12px;
          margin-top: 4px;
        }
        .success-message {
          color: #5cb85c;
          margin: 10px 0;
          text-align: center;
        }
        .error-message {
          color: #d9534f;
          margin: 10px 0;
          text-align: center;
        }
      `}</style>

      <Modal
        show={show}
        onHide={onHide}
        centered
        className="modal-xl"
        style={{ paddingLeft: "0px" }}
      >
        <Modal.Body className="bg-E2F1FE position-relative box-shadow-one rounded-4 p-23 pt-2 p-sm-23 z-0">
          <Modal.Header className="popup-header" closeButton></Modal.Header>
          <Image
            src={LayerFour}
            className="position-absolute bottom-0 start-0 w-40"
            style={{ zIndex: "-1" }}
          />
          <Row className="align-items-center">
            {!isSubmitted && (
              <Col md={5} className="text-center mb-3 mb-md-0">
                <div className="text-left">
                  <h2 className="section-heading fw-700 fs-2">
                    {whitepaperTitle}
                  </h2>
                  <span
                    style={{
                      background: "#e30016",
                      width: "35%",
                      height: "6px",
                      display: "block",
                    }}
                  ></span>
                </div>
              </Col>
            )}
            <Col lg={isSubmitted ? 12 : 7}>
              {!isSubmitted ? (
                <Form onSubmit={handleSubmit}>
                  <Row className="pb-3 mt-3 mt-lg-0">
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Full Name <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          isInvalid={!!errors.name}
                        />
                        {errors.name && (
                          <div className="error-text">{errors.name}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Business Email <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="email"
                          placeholder=""
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          isInvalid={!!errors.email}
                        />
                        {errors.email && (
                          <div className="error-text">{errors.email}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>
                          Company Name <span class="text-danger">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder=""
                          name="company"
                          value={formData.company}
                          onChange={handleChange}
                          isInvalid={!!errors.company}
                        />
                        {errors.company && (
                          <div className="error-text">{errors.company}</div>
                        )}
                      </Form.Group>
                    </Col>
                    <Col lg={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Contact Number</Form.Label>
                        <Form.Control
                          type="tel"
                          placeholder="Enter 10-digit phone number"
                          name="mobile"
                          value={formData.mobile}
                          onChange={handleChange}
                          isInvalid={!!errors.mobile}
                        />
                        {errors.mobile && (
                          <div className="error-text">{errors.mobile}</div>
                        )}
                      </Form.Group>
                    </Col>
                    {responseMessage && (
                      <div
                        className={
                          responseMessage.includes("correct")
                            ? "error-message"
                            : "error-message"
                        }
                      >
                        {responseMessage}
                      </div>
                    )}
                    <Col lg={12} className="mt-4">
                      <Button
                        variant="danger"
                        type="submit"
                        className=""
                        disabled={loading}
                      >
                        {loading ? "Submitting..." : "Submit"}
                      </Button>
                    </Col>
                  </Row>
                </Form>
              ) : (
                <div className="text-center py-5">
                  <h2 className="section-heading text-center fw-700 fs-2 mb-4">
                    <span className="bordered-text">Thank You!</span>
                  </h2>
                  {/* <p>{responseMessage}</p> */}
                  <p className="fs-6 mb-4 fw-700">
                    The PDF white paper has been sent to the email address you
                    provided.
                    <br></br>Please check your inbox (or spam/junk folder) to
                    download it.
                  </p>
                </div>
              )}
            </Col>

            {/* {isSubmitted && (
              <div style={{ textAlign: "center", padding: "20px 0" }}>
                <div
                  style={{
                    fontSize: "48px",
                    marginBottom: "15px",
                    color: "#5cb85c",
                  }}
                >
                  ✓
                </div>
                <p
                  style={{
                    color: "#0f172a",
                    fontSize: "16px",
                    fontWeight: 600,
                  }}
                >
                  {responseMessage}
                </p>
                <p style={{ color: "#6b7280", fontSize: "14px" }}>
                  The download link has been sent to your email.
                </p>
                <Button
                  variant="outline-danger"
                  onClick={onHide}
                  style={{ marginTop: "15px" }}
                >
                  Close
                </Button>
              </div>
            )} */}
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WhitepaperModal;
